import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PeepsBook from './peeps-book.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PeepsBook {...validProps} />;
}

SvgComponent.iconName = 'peepsBook';

export const PeepsBookIcon = svgIconWrapper(SvgComponent);
